import { useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { StudioHeaderContext } from './studio-header-context';

/** Продуктовый экран заполняет общий слот шапки, не создавая вторую шапку в теле. */
export function StudioHeaderContent({ children, enabled = true }: { children: ReactNode; enabled?: boolean }) {
  const host = useContext(StudioHeaderContext);
  return host && enabled ? createPortal(<div className="studio-header-content">{children}</div>, host) : null;
}
